<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-storage-container"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Height"><FormInputText placeholder="Height" v-model="glassSize.height" field="height" addon="mm" /></FormRow>
      <FormRow label="Width"><FormInputText placeholder="Width" v-model="glassSize.width" field="width" addon="mm" /></FormRow>
      <FormRow label="Container Type"><FormSelect v-model="glassSize.stockContainerId" field="stockContainerId" :optionsPromise="containerOptionsPromise" /></FormRow>
      <FormRow label="Block Size"><FormInputText placeholder="Block Size" v-model="glassSize.blockSize" field="blockSize" /></FormRow>
      <FormRow label="Maintain Level"><FormInputText placeholder="Maintain Level" v-model="glassSize.maintainLevel" field="maintainLevel" /></FormRow>
      <FormRow label="Required Days of Stock" helpTip="Number of business days of average usage required to keep in stock. Used for purchasing planning">
        <FormInputText placeholder="Required Days of Stock" v-model="glassSize.requiredDaysOfStock" field="requiredDaysOfStock" />
      </FormRow>
      <FormRow label="Preferred Supplier"><FormSelect v-model="glassSize.preferredSupplierId" field="preferredSupplierId" :optionsPromise="supplierOptionsPromise" /></FormRow>
      <FormHorizontalRule v-if="stockUsesGrainDirection" />
      <FormRow label="Grain Direction" v-if="stockUsesGrainDirection">
        <FormSelect v-model="glassSize.grainDirection" field="grainDirection" :options="StockGrainDirectionTypeLookup" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { StockGrainDirectionTypes, StockGrainDirectionTypeLookup } from '@/store/types'

export default {
  name: 'GlassSizeDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean,
    stock: Object,
    stockId: Number
  },
  data() {
    return {
      id: null,
      glassSize: {},
      dialogForm: {},
      submitting: false,
      containerOptionsPromise: this.getContainerOptionsPromise(),
      supplierOptionsPromise: this.getSupplierOptionsPromise(),
    }
  },
  created() {
    this.StockGrainDirectionTypeLookup = StockGrainDirectionTypeLookup
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Glass Size' : 'Edit Glass Size'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    },
    stockUsesGrainDirection() {
      if(!this.stock)
        return false
      return !!this.stock.isStockUsingGrain
    }
  },
  methods: {
    show(glassSize) {
      // Reset form
      this.glassSize = {
        grainDirection: StockGrainDirectionTypes.vertical
      }
      this.id = 0
      this.dialogForm = {}
      this.submitting = false

      if(glassSize != null) {
        this.glassSize = _.cloneDeep(glassSize)
        this.id = glassSize.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.glassSize)
      updateData = _.pick(updateData, [
        'height', 'width', 'blockSize', 'maintainLevel', 'requiredDaysOfStock', 'stockContainerId', 'preferredSupplierId', 'grainDirection'
      ])

      if(this.isCreateMode) {
        this.$apiService.inventoryService.createGlassSize(this.stockId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.inventoryService.updateGlassSize(this.stockId, this.id, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    },
    getContainerOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.inventoryService.getStockContainerList()
        .then(response => {
          resolve(response.data.filter(container => container.isActive).map(container => {
            return { value: container.id, name: `${container.code} - ${container.name}` }
          }))
        })
        .catch(() => { reject() })
      })
    },
    getSupplierOptionsPromise() {
      return new Promise((resolve, reject) => {
        return this.$apiService.contactService.getContactList({
          isActive: 1,
          isSupplier: 1,
          isSupplierPricingBulk: 1
        })
        .then(response => {
          var supplierOptions = response.data.map(supplier => {
            return { value: supplier.id, name: supplier.name }
          })
          resolve(_.concat({ value: null, name: 'None' }, supplierOptions))
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>